<template>
  <div class="reservationBackground" @mousedown="closeReservationModal">
    <div class="reservationBlock" :class="isShowNotify || isShowTpNotice ? 'showPopUp' : null">
      <div class="modalHeader">
        <img src="../assets/icons/logo.svg" />
        <div class="closeAuth" @click="closeModal">
          <svg
            width="15"
            height="15"
            viewBox="0 0 15 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 14L13.7279 1.27208"
              stroke="#2F2F2F"
              stroke-width="2"
              stroke-linecap="round"
            />
            <path
              d="M1 1L13.7279 13.7279"
              stroke="#2F2F2F"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </div>
      </div>
      <div class="firstStep" v-if="!isPaymentStep">
        <p class="reservationHeadText">Бронирование услуг</p>
        <Flicking
          :options="{
            renderOnlyVisible: false,
            panelsPerView: 2,
            align: 'prev',
            bound: true,
            duration: 100,
            deceleration: 0.0005,
            noPanelStyleOverride: true,
            inputType: ['mouse', 'pointer'],
          }"
          style="padding-bottom: 10px"
        >
          <div
            class="depositMethod selectedDepositMethod"
            id="card"
            @click="changePaymentMethod"
            :key="1"
          >
            <div class="depositMethodHeader">
              <img src="../assets/icons/paymentMethods/card.svg" />
              <img src="../assets/icons/paymentMethods/dot.svg" v-if="type == 'card'" />
            </div>
            <div class="depositMethodFooter">
              <p>Банковская карта RU</p>
            </div>
          </div>
          <div class="depositMethod" id="sbp" @click="changePaymentMethod" :key="2" v-if="sbp">
            <div class="depositMethodHeader">
              <img src="../assets/icons/paymentMethods/card.svg" />
              <img src="../assets/icons/paymentMethods/dot.svg" v-if="type == 'sbp'" />
            </div>
            <div class="depositMethodFooter">
              <p>Система быстрых платежей</p>
            </div>
          </div>
          <div class="depositMethod" id="card" @click="showNal" :key="0">
            <div class="depositMethodHeader">
              <img src="../assets/icons/paymentMethods/wallet.svg" />
            </div>
            <div class="depositMethodFooter">
              <p>Наличный расчет</p>
            </div>
          </div>
          <div
            class="depositMethod"
            id="card_ua"
            v-if="card_ua"
            @click="changePaymentMethod"
            :key="3"
          >
            <div class="depositMethodHeader">
              <img src="../assets/icons/paymentMethods/card.svg" />
              <img src="../assets/icons/paymentMethods/dot.svg" v-if="type == 'card_ua'" />
            </div>
            <div class="depositMethodFooter">
              <p>Банковская карта UA</p>
            </div>
          </div>
          <div
            class="depositMethod"
            id="card_kz"
            v-if="card_kz"
            @click="changePaymentMethod"
            :key="4"
          >
            <div class="depositMethodHeader">
              <img src="../assets/icons/paymentMethods/card.svg" />
              <img src="../assets/icons/paymentMethods/dot.svg" v-if="type == 'card_kz'" />
            </div>
            <div class="depositMethodFooter">
              <p>Банковская карта KZ</p>
            </div>
          </div>
          <div class="depositMethod" id="card_kg" @click="changePaymentMethod" :key="5">
            <div class="depositMethodHeader">
              <img src="../assets/icons/paymentMethods/card.svg" />
              <img src="../assets/icons/paymentMethods/dot.svg" v-if="type == 'card_kg'" />
            </div>
            <div class="depositMethodFooter">
              <p>Банковская карта (любая страна)</p>
            </div>
          </div>
          <div class="depositMethod" id="usdt" @click="changePaymentMethod" :key="6">
            <div class="depositMethodHeader">
              <img src="../assets/icons/paymentMethods/usdt.svg" />
              <img src="../assets/icons/paymentMethods/dot.svg" v-if="type == 'usdt'" />
            </div>
            <div class="depositMethodFooter">
              <p>USDT (Tether)</p>
            </div>
          </div>
          <div class="depositMethod" id="eth" @click="changePaymentMethod" :key="7">
            <div class="depositMethodHeader">
              <img src="../assets/icons/paymentMethods/eth.svg" />
              <img src="../assets/icons/paymentMethods/dot.svg" v-if="type == 'eth'" />
            </div>
            <div class="depositMethodFooter">
              <p>ETH (Ethereum)</p>
            </div>
          </div>
          <div class="depositMethod" id="btc" @click="changePaymentMethod" :key="8">
            <div class="depositMethodHeader">
              <img src="../assets/icons/paymentMethods/btc.svg" />
              <img src="../assets/icons/paymentMethods/dot.svg" v-if="type == 'btc'" />
            </div>
            <div class="depositMethodFooter">
              <p>BTC (Bitcoin)</p>
            </div>
          </div>
        </Flicking>
        <div class="signSelector">
          <div class="slider" :class="{ moveRight: place === 'modelPlace' }"></div>
          <p class="myPlace" @click="changePlace" :class="{ selectedSign: place === 'myPlace' }">
            Ваше место
          </p>
          <p
            class="modelPlace"
            @click="changePlace"
            :class="{ selectedSign: place === 'modelPlace' }"
          >
            Место модели
          </p>
        </div>
        <Transition name="fade">
          <div
            v-if="type == 'card'"
            class="bankSelector"
            v-click-outside="() => (isShowBankList = false)"
          >
            <p class="inputText">Банк</p>
            <div class="bankSelect" @click="isShowBankList = !isShowBankList">
              <div class="selectedBank">
                <img :src="selectedBank.icon" />
                <p>{{ selectedBank.name }}</p>
              </div>
              <img src="../assets/icons/triangleDown.svg" :class="{ rotate: isShowBankList }" />
            </div>
            <Transition name="fade">
              <div class="bankList" v-if="isShowBankList">
                <div
                  class="bankItem"
                  v-for="bank in banks"
                  :key="bank.value"
                  @click="selectBank(bank)"
                >
                  <img :src="bank.icon" />
                  <p>{{ bank.name }}</p>
                </div>
              </div>
            </Transition>
          </div>
        </Transition>
        <div class="phoneInput">
          <p class="inputText">Номер телефона</p>
          <input
            type="search"
            id="phone"
            placeholder="+7 (999) 999-99-99"
            v-model="phone"
            @input="validatePhoneNumber"
          />
        </div>
        <Transition name="fade">
          <div class="addressInput" v-if="place == 'myPlace'">
            <p class="inputText">Адрес</p>
            <input
              type="text"
              id="address"
              placeholder="Введите ваш адрес (улица, дом, квартира)"
              v-model="address"
            />
          </div>
        </Transition>
        <div class="commentInput">
          <p class="inputText">Комментарий для модели*</p>
          <div class="commentInputArea">
            <textarea
              type="text"
              id="comment"
              placeholder="Здесь может быть ваш комментарий"
              maxlength="128"
              v-model="comment"
            />
            <p>{{ comment.length }}/128</p>
          </div>
        </div>
        <div class="bottomReservation">
          <div class="bottomBlock">
            <div class="changeBottomHead">
              <p class="inputText" style="margin-bottom: 0">Время</p>
              <button class="allNightButton" @click="allNight">
                На всю ночь
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 384 512"
                >
                  <path
                    d="M223.5 32C100 32 0 132.3 0 256S100 480 223.5 480c60.6 0 115.5-24.2 155.8-63.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6c-96.9 0-175.5-78.8-175.5-176c0-65.8 36-123.1 89.3-153.3c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8z"
                  />
                </svg>
              </button>
            </div>
            <div class="changeBottomBlock">
              <div class="changeBottomInput">
                <!-- <input class='timeArea' id='cityArea' @click='showCityListClick' readonly placeholder='Москва' v-model='city'/> -->
                <img
                  src="../assets/icons/triangleDown.svg"
                  :class="isShowCalendar ? 'calendarShow' : ''"
                />
                <div class="calendarPicker" @click="showCalendar">
                  <p>
                    {{
                      date == null
                        ? "Выберите дату"
                        : date
                            .toLocaleString("ru-RU", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: false,
                            })
                            .replace(",", " | ")
                    }}
                    {{
                      endDate
                        ? " - " +
                          endDate
                            .toLocaleString("ru-RU", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: false,
                            })
                            .replace(",", " | ")
                        : ""
                    }}
                  </p>
                </div>
                <DatePicker
                  @newDate="changeDate"
                  @newEndDate="changeEndDate"
                  @hideDatePicker="hideDatePicker"
                  v-if="isShowCalendar"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="discountSummary" v-if="activeDiscount">
          <div class="discountBadge">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7 7H7.01M17 17H17.01M6 13.2V6.8C6 6.11994 6.11927 5.69063 6.33378 5.36254C6.52214 5.07473 6.77473 4.82214 7.06254 4.63378C7.39063 4.41927 7.81994 4.3 8.5 4.3H14.9C15.2366 4.3 15.4048 4.3 15.563 4.33803C15.7032 4.37172 15.8373 4.42689 15.9607 4.50155C16.1 4.58579 16.219 4.70482 16.4571 4.94289L19.0571 7.54289C19.2952 7.78097 19.4142 7.9 19.4985 8.03932C19.5731 8.16275 19.6283 8.2968 19.662 8.43704C19.7 8.59516 19.7 8.76344 19.7 9.1V15.5C19.7 16.1801 19.5807 16.6094 19.3662 16.9375C19.1779 17.2253 18.9253 17.4779 18.6375 17.6662C18.3094 17.8807 17.8801 18 17.2 18H10.8C10.1199 18 9.69063 17.8807 9.36254 17.6662C9.07473 17.4779 8.82214 17.2253 8.63378 16.9375C8.41927 16.6094 8.3 16.1801 8.3 15.5V14.7"
                stroke="currentColor"
                stroke-width="1.7"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M9 15L15 9"
                stroke="currentColor"
                stroke-width="1.7"
                stroke-linecap="round"
              />
            </svg>
            Скидка {{ activeDiscount.percent }}%
          </div>
          <div class="discountPriceInfo" v-if="baseAmount">
            <div class="discountPriceRow">
              <span>Без скидки</span>
              <span>{{ formatPrice(baseAmount) }}</span>
            </div>
            <div class="discountPriceRow totalDiscountPrice">
              <span>К оплате</span>
              <span>{{ formatPrice(discountedAmount) }}</span>
            </div>
          </div>
          <p class="discountHint">Скидка применится автоматически при создании заказа.</p>
        </div>
        <button class="goPayment" @click="goPayment">
          <div class="loader" v-if="waitingPayment"></div>
          <p v-else>Перейти к оплате</p>
        </button>
        <!-- <button @click='testData'>sssss</button> -->
        <div class="saveAddress">
          <input id="saveAddress" type="checkbox" />
          <label for="saveAddress" class="inputText" style="margin-bottom: 0"
            >Запомнить адрес для следующих заказов</label
          >
        </div>
      </div>
      <div class="secondStep" v-else>
        <PaymentCard :paymentData="paymentData" />
      </div>
    </div>
    <Transition name="fade">
      <div class="popUpNotifyBlock" v-if="isShowNotify">
        <div class="popUpNotify">
          <div class="popUpNotifyContent">
            <div class="modalHeader" style="margin-bottom: 10px">
              <img src="../assets/icons/logo.svg" />
              <div class="closeAuth" @click="isShowNotify = false">
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 14L13.7279 1.27208"
                    stroke="#2F2F2F"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                  <path
                    d="M1 1L13.7279 13.7279"
                    stroke="#2F2F2F"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>
              </div>
            </div>
            <hr style="border: 1px solid #2f2f2f50; margin-bottom: 10px" />
            <!-- <p class="popUpHead">Уведомление</p> -->
            <p class="popUpText">Пожалуйста, для проведения платежа обратитесь в тех. поддержку.</p>
            <button class="writeUs" @click="supportClick">
              <img src="../assets/icons/paperPlane.svg" />
              Написать нам
            </button>
          </div>
        </div>
      </div>
    </Transition>
    <!-- TP: плашка «Оплата через поддержку». Сейчас не показываем — просто открываем
         чат и закрываем окно заказа. Оставлено на случай возврата.
    <Transition name="fade">
      <div class="popUpNotifyBlock" v-if="isShowTpNotice">
        <div class="popUpNotify">
          <div class="popUpNotifyContent">
            <div class="modalHeader" style="margin-bottom: 10px">
              <img src="../assets/icons/logo.svg" />
              <div class="closeAuth" @click="isShowTpNotice = false">
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 14L13.7279 1.27208"
                    stroke="#2F2F2F"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                  <path
                    d="M1 1L13.7279 13.7279"
                    stroke="#2F2F2F"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>
              </div>
            </div>
            <hr style="border: 1px solid #2f2f2f50; margin-bottom: 10px" />
            <p class="popUpHeadText">Оплата через поддержку</p>
            <p class="popUpText">
              Оплата в данный момент производится через техподдержку. Мы уже отправили ваше сообщение
              оператору — продолжите в чате поддержки.
            </p>
            <button class="writeUs" @click="isShowTpNotice = false">Продолжить</button>
          </div>
        </div>
      </div>
    </Transition>
    -->
  </div>
</template>

<script>
import axios from "axios";
import { useToast } from "vue-toastification";
import { openChatWidget, sendSupportMessage } from "@/utils/chatWidget";

import PaymentCard from "./PaymentCard.vue";

// Человекочитаемые подписи способов оплаты для сообщения в техподдержку.
// Должны совпадать с backend getTpDepositLabel, чтобы воркер видел тот же текст.
const TP_BANK_LABELS = {
  alfa: "Альфа-Банк",
  sber: "СберБанк",
  tinkoff: "Тинькофф Банк",
  vtb: "ВТБ Банк",
};
const TP_METHOD_LABELS = {
  card_ua: "Оплата картой — Украина",
  card_kz: "Оплата картой — Казахстан",
  card_kg: "Оплата картой — Весь мир",
  sbp: "Оплата через СБП",
  usdt: "Оплата криптовалютой — USDT",
  eth: "Оплата криптовалютой — ETH",
  btc: "Оплата криптовалютой — BTC",
};
import Flicking from "@egjs/vue3-flicking";
import DatePicker from "./DatePicker.vue";

export default {
  name: "ReservationComponent",
  data() {
    return {
      place: "myPlace",
      paymentPlace: "ME",
      phone: this.$store.getters.getUserData.phone_number,
      address: this.$store.getters.getAddress,
      comment: "",
      type: "card",
      isPaymentStep: false,
      isDragging: false,
      startX: 0,
      startY: 0,
      paymentData: {},
      waitingPayment: false,
      isPickerDisabled: false,
      isAllNight: false,
      date: null,
      endDate: null,
      isShowCalendar: false,
      isShowNotify: false,
      isShowTpNotice: false,
      card_ua: false,
      card_kz: false,
      sbp: false,
      tp: false,
      banks: [
        { name: "Сбербанк", icon: require("../assets/icons/banks/sber.svg"), value: "sber" },
        { name: "Альфа-Банк", icon: require("../assets/icons/banks/alfa.svg"), value: "alfa" },
        {
          name: "Тинькофф Банк",
          icon: require("../assets/icons/banks/tinkoff.svg"),
          value: "tinkoff",
        },
        { name: "ВТБ Банк", icon: require("../assets/icons/banks/vtb.svg"), value: "vtb" },
        { name: "Другой", icon: require("../assets/icons/banks/any.svg"), value: "any" },
      ],
      selectedBank: {
        name: "Сбербанк",
        icon: require("../assets/icons/banks/sber.svg"),
        value: "sber",
      },
      isShowBankList: false,
      discounts: [],
    };
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  props: {
    girlId: {
      type: String,
    },
    oneHourPrice: {
      type: Number,
    },
    nightPrice: {
      type: Number,
    },
  },
  methods: {
    formatPrice(value) {
      return `${Math.round(value).toLocaleString("ru-RU")} RUB`;
    },
    getMatchingDiscount() {
      return (
        this.discounts
          .filter((discount) => !discount.girlId || String(discount.girlId) === String(this.girlId))
          .sort((a, b) => (b.percent || 0) - (a.percent || 0))[0] || null
      );
    },
    changePlace(event) {
      let place = event.target.classList[0];
      let elem = document.querySelector(`.${place}`);
      let selector = document.querySelector(".selectedSign");
      let slider = document.querySelector(".slider");
      selector.classList.remove("selectedSign");
      elem.classList.add("selectedSign");
      if (place === "myPlace") {
        if (window.innerWidth > 968) slider.style.width = "12vw";
        else slider.style.width = "38vw";
        this.place = "myPlace";
        this.paymentPlace = "ME";
      } else {
        if (window.innerWidth > 968) slider.style.width = "12.2vw";
        else slider.style.width = "39vw";
        this.place = "modelPlace";
        this.paymentPlace = "YOU";
      }
    },
    changeDate(date) {
      console.log(date);
      this.date = date;
    },
    supportClick() {
      openChatWidget();
    },
    showCalendar() {
      if (!this.isAllNight) this.isShowCalendar = !this.isShowCalendar;
    },
    changeEndDate(date) {
      this.endDate = date;
    },
    hideDatePicker() {
      this.isShowCalendar = false;
      console.log(this.isShowCalendar);
    },
    allNight(event) {
      let e = event.target.closest("button");
      let svg = e.querySelector("svg");
      if (e.classList.length > 1) {
        e.className = "allNightButton";
        svg.style.fill = "#333333";
        this.date = undefined;
        this.endDate = undefined;
        this.isPickerDisabled = false;
        this.isAllNight = false;
      } else {
        e.classList.add("toggleAllNight");
        if (new Date().getHours() < 22) {
          this.date = new Date(new Date().setHours(22, 0, 0, 0));
          this.endDate = new Date(
            new Date(new Date().setDate(new Date().getDate() + 1)).setHours(6, 0, 0, 0),
          );
        } else {
          this.date = new Date(new Date().setHours(new Date().getHours() + 1, 0, 0, 0));
          this.endDate = new Date(
            new Date(new Date().setDate(new Date().getDate() + 1)).setHours(6, 0, 0, 0),
          );
        }
        this.isPickerDisabled = true;
        this.isAllNight = true;
        svg.style.fill = "white";
      }
    },
    changePaymentMethod(event) {
      if (!this.isDragging) {
        let e = event.target.closest(".depositMethod");
        let elements = document.querySelectorAll(".depositMethod");
        for (let els of elements) els.style.border = "1px solid transparent";
        e.style.border = "1px solid #333333";

        this.type = e.id;
      }
    },
    showNal() {
      this.toast.error(
        "Оплата наличными доступна только после подтверждения первого заказа в мерах безопасности.",
      );
    },
    closeModal() {
      this.$emit("close-auth");
    },
    closeReservationModal(event) {
      if (
        (this.isShowNotify || this.isShowTpNotice) &&
        !document.querySelector(".popUpNotify").contains(event.target)
      ) {
        this.isShowNotify = false;
        this.isShowTpNotice = false;
      } else if (event.target.className == "reservationBackground") this.closeModal();
    },
    tpLabel(method, bank) {
      if (method === "card") {
        const label = bank && bank !== "any" ? TP_BANK_LABELS[bank] : null;
        return label ? `Оплата картой — ${label}` : "Оплата картой — Россия";
      }
      return TP_METHOD_LABELS[method] || method;
    },
    buildTpMessage(amount) {
      const label = this.tpLabel(this.type, this.selectedBank?.value);
      const amountText = new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 })
        .format(Number(amount) || 0)
        .replace(/,/g, " ");
      return `Добрый день, оплата заказа «${label}» ${amountText} ₽`;
    },
    validatePhoneNumber() {
      const x = this.phone
        .replace(/\D/g, "")
        .match(/(\d{0,1})(\d{0,3})(\d{0,3})(\d{0,2})(\d{0,2})/);
      x[1] = "+7";
      this.phone = !x[3]
        ? x[1] + " (" + x[2]
        : x[1] + " (" + x[2] + ") " + x[3] + (x[4] ? "-" + x[4] : "") + (x[5] ? "-" + x[5] : "");
    },
    goPayment() {
      if (document.querySelector("#saveAddress").checked)
        this.$store.commit("setAddress", this.address);

      if (
        this.date != undefined &&
        this.date != null &&
        this.endDate != null &&
        !this.waitingPayment
      ) {
        const differenceInMs = this.endDate - this.date;
        const differenceInHours = differenceInMs / (1000 * 60 * 60);
        console.log(this.oneHourPrice * differenceInHours);
        this.waitingPayment = true;
        axios
          .post(
            // Пополнение через ТП: реквизиты не выдаём — заказ создаётся без похода в платёжку
            `https://${process.env.VUE_APP_SERVERHOST}/api/order${this.tp ? "/tp" : ""}`,
            {
              phone_number: this.phone.replace(/[\s()-]/g, ""),
              girlId: this.girlId,
              address: this.address,
              place: this.paymentPlace,
              startOrder: Date.parse(this.date),
              endOrder: Date.parse(this.endDate),
              amount: this.isAllNight ? this.nightPrice : this.oneHourPrice * differenceInHours,
              comment: this.comment,
              type: this.type,
              type_card:
                this.type == "card"
                  ? this.selectedBank.value == "any"
                    ? undefined
                    : this.selectedBank.value
                  : undefined,
            },
            {
              headers: {
                Authorization: "Bearer " + this.$store.state.userData.token,
              },
            },
          )
          .then((res) => {
            console.log(res);
            if (this.tp) {
              this.waitingPayment = false;
              // Открываем чат поддержки и закрываем окно заказа — плашку-уведомление
              // не показываем (её разметка закомментирована ниже, на случай возврата).
              sendSupportMessage(this.buildTpMessage(res.data.result?.payment?.amount));
              this.closeModal();
              return;
            }
            if (res.data.result.payment.details.fio_card != null) {
              this.paymentData = res.data.result;
              this.isPaymentStep = true;
              this.waitingPayment = false;
            } else {
              if (res.data.ok == true) {
                this.paymentData = res.data.result;
                this.isPaymentStep = true;
                this.waitingPayment = false;
              } else {
                this.toast.error("Ошибка платежа. Попробуйте позже!");
                this.waitingPayment = false;
              }
            }
          })
          .catch((err) => {
            console.log(err);
            if (this.oneHourPrice * differenceInHours > 20000) null;
            else this.toast.error(err.response.data.message);
            this.isShowNotify = true;
            this.isPaymentStep = false;
            this.waitingPayment = false;
          });
      } else {
        if (this.waitingPayment) this.toast.error("Оплата формируется, ожидайте.");
        else this.toast.error("Вы не выбрали дату и время заказа!");
      }
    },
    onMouseDown(event) {
      this.startX = event.clientX;
      this.startY = event.clientY;
    },
    onMouseUp(event) {
      const deltaX = Math.abs(event.clientX - this.startX);
      const deltaY = Math.abs(event.clientY - this.startY);
      this.isDragging = deltaX > 5 || deltaY > 5;
    },
    selectBank(bank) {
      this.selectedBank = bank;
      this.isShowBankList = false;
    },
    isNightTime(date) {
      const hours = date.getHours(); // Получаем часы из даты

      // Проверяем, находится ли время в диапазоне ночи
      return hours >= 22 || hours < 6;
    },
    areDatesInNightRange(date1, date2) {
      return this.isNightTime(date1) && this.isNightTime(date2);
    },
    getAvailablePS() {
      axios
        .get(`https://${process.env.VUE_APP_SERVERHOST}/api/payment/availableps`, {
          headers: {
            Authorization: "Bearer " + this.$store.state.userData.token,
          },
        })
        .then((res) => {
          this.card_kz = res.data.result.card_kz;
          this.card_ua = res.data.result.card_ua;
          this.sbp = res.data.result.sbp;
          // Режим «пополнение через ТП»: включается воркером глобально или лично клиенту
          this.tp = res.data.result.tp ?? false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getDiscounts() {
      axios
        .get(`https://${process.env.VUE_APP_SERVERHOST}/api/discount`, {
          headers: {
            Authorization: "Bearer " + this.$store.state.userData.token,
          },
        })
        .then((res) => {
          this.discounts = Array.isArray(res.data?.result) ? res.data.result : [];
        })
        .catch((err) => {
          this.discounts = [];
          console.log(err);
        });
    },
  },
  computed: {
    baseAmount() {
      if (!this.date || !this.endDate) return 0;

      if (this.isAllNight) return this.nightPrice;

      const differenceInMs = this.endDate - this.date;
      const differenceInHours = differenceInMs / (1000 * 60 * 60);

      if (differenceInHours <= 0) return 0;

      return this.oneHourPrice * differenceInHours;
    },
    activeDiscount() {
      return this.getMatchingDiscount();
    },
    discountedAmount() {
      if (!this.activeDiscount || !this.baseAmount) return this.baseAmount;
      return this.baseAmount - (this.baseAmount * this.activeDiscount.percent) / 100;
    },
  },
  components: {
    PaymentCard,
    Flicking,
    DatePicker,
  },
  directives: {
    "click-outside": {
      mounted(el, binding) {
        el.clickOutsideEvent = function (event) {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value(event);
          }
        };
        document.body.addEventListener("click", el.clickOutsideEvent);
      },
      unmounted(el) {
        document.body.removeEventListener("click", el.clickOutsideEvent);
      },
    },
  },
  mounted() {
    this.getAvailablePS();
    this.getDiscounts();
  },
};
</script>

<style scoped>
.reservationBackground {
  background-color: #232323e5;
  backdrop-filter: blur(8px);
  color: white;
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 5002;
  display: flex;
  align-items: center;
  justify-content: center;
}
.reservationBlock {
  width: 30vw;
  margin: 0 auto;
  max-height: 95vh;
  border-radius: 10px;
  background-color: #ffffff;
  padding: 1% 2% 1% 2%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: relative;
  transition: transform 0.3s ease, opacity 0.3s ease, height 0.3s ease-in-out;
  overflow-y: auto;
}
.firstStep {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.modalHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.closeAuth {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #2f2f2f;
  border-radius: 5px;
  padding: 2%;
  cursor: pointer;
}
.reservationHeadText {
  font-size: 24px;
  font-weight: 600;
  color: #333333;
}
.signSelector {
  background-color: #f6fafd;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  padding: 1%;
  width: auto;
  gap: 5px;
  color: #333333;
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  height: 100%;
  position: relative;
  align-self: flex-start;
  margin-bottom: 20px;
}
.signSelector p {
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  cursor: pointer;
  transform: color 0.8s;
  user-select: none;
}
.myPlace {
  width: 12vw;
}
.modelPlace {
  width: 12vw;
}
.selectedSign {
  /* background-color: #2F2F2F; */
  color: #ffffff;
  border-radius: 10px;
}
.slider {
  position: absolute;
  top: 5px;
  bottom: 5px;
  left: 5px;
  width: 12vw;
  background-color: #2f2f2f;
  border-radius: 10px;
  transition: transform 0.5s ease, width 0.8s;
  z-index: 1; /* За текстом */
}
.slider.moveRight {
  transform: translateX(99%);
}
.inputText {
  color: #333333;
  font-size: 14px;
  margin-bottom: 10px;
  user-select: none;
}
.commentInputArea {
  position: relative;
}
.commentInputArea textarea {
  width: 100%;
  height: 100%;
  resize: none;
  height: 12vh;
}
.commentInputArea p {
  position: absolute;
  right: 15px;
  bottom: 20px;
  color: #00000080;
  user-select: none;
}
.bottomReservation {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}
.bottomBlock {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.changeBottomHead {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  align-items: center;
}
.changeBottomHead input {
  width: auto;
}
.changeBottomBlock {
  display: flex;
  position: relative;
}
.changeBottomInput {
  display: flex;
  position: relative;
  width: 100%;
}
.calendarPicker {
  outline: none;
  background-color: #ffffff;
  border-radius: 10px;
  border: 1px solid #d8dadc;
  padding: 15px;
  width: 100%;
  color: #333333;
  position: relative;
  cursor: pointer;
}
.dropDownList {
  height: auto;
  width: auto;
  position: absolute;
  bottom: 120%;
  right: 0;
  background-color: #fbfbfb;
  border: 1px solid #f4f4f4;
  border-radius: 10px;
  overflow-y: auto;
  padding: 7%;
  z-index: 5;
}
.dropDownText {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
  margin-left: 17px;
}
.dropDownList * {
  color: #333333;
}
.dropDownList ul {
  list-style-type: none;
  padding: 0;
}
.dropDownList ul li {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  margin-bottom: 5px;
}
.dropDownList ul li svg rect {
  width: 14px;
  height: 14px;
}
.changeBottomInput img {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  transition: 0.6s ease;
  z-index: 2;
}
.calendarShow {
  transform: translateY(-50%) rotate(180deg) !important;
}
.timeArea {
  resize: none;
  outline: none;
  border: 1px solid #d8dadc;
  border-radius: 10px;
  padding: 15px;
  height: fit-content;
  background-color: #ffffff;
  width: 100%;
  cursor: pointer;
}
.goPayment {
  width: 100%;
  background-color: #ff8989;
  border-radius: 10px;
  border: 1px solid #ff8989;
  color: white;
  font-weight: 600;
  padding: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
}
.discountSummary {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px;
  border-radius: 12px;
  background-color: #fff4f4;
  border: 1px solid #ffd2d2;
}
.discountBadge {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 700;
  color: #ff6f6f;
}
.discountPriceInfo {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.discountPriceRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  color: #333333;
  font-size: 14px;
}
.totalDiscountPrice {
  font-weight: 700;
}
.discountHint {
  color: #7a7a7a;
  font-size: 12px;
}
.saveAddress {
  display: flex;
  gap: 10px;
  align-items: center;
}
.saveAddress input {
  -webkit-appearance: none;
  appearance: none;
  background-color: #fff;
  margin: 0;
  font: inherit;
  color: currentColor;
  width: 20px;
  height: 20px;
  border: 1px solid #d8dadc;
  border-radius: 2px;
  display: grid;
  place-content: center;
  padding: 0 !important;
}
.saveAddress input::before {
  content: "";
  width: 10px;
  height: 10px;
  transform: scale(0);
  transition: 120ms transform ease-in-out;
  box-shadow: inset 10px 10px #ff8989;
}
.saveAddress input:checked::before {
  transform: scale(1);
}
.saveAddress input:checked {
  border: 1px solid #ff8989;
}
.saveAddress p {
  color: #333333;
}
.dropDownShowImg {
  transform: rotate(180deg) translateY(50%) !important;
}
.bankSelector {
  position: relative;
  display: flex;
  flex-direction: column;
}
.bankSelect {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  border: 1px solid #d8dadc;
  border-radius: 10px;
  cursor: pointer;
  background: white;
  user-select: none;
}
.selectedBank {
  display: flex;
  align-items: center;
  gap: 10px;
}
.selectedBank img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}
.selectedBank p {
  color: #333333;
  font-size: 14px;
  font-weight: 500;
}
.bankSelect img:last-child {
  width: 12px;
  transition: transform 0.3s ease;
}
.bankSelect img.rotate {
  transform: rotate(180deg);
}
.bankList {
  position: absolute;
  top: 105%;
  left: 0;
  width: 100%;
  background: white;
  border: 1px solid #d8dadc;
  border-radius: 10px;
  z-index: 10;
  max-height: 200px;
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.bankItem {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 15px;
  cursor: pointer;
  transition: background 0.2s ease;
}
.bankItem:hover {
  background: #f6fafd;
}
.bankItem img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}
.bankItem p {
  color: #333333;
  font-size: 14px;
}
.depositMethod {
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  background-color: #f6fafd;
  padding: 3% 5% 3% 5%;
  flex: 0 0 45%;
  gap: 15px;
  user-select: none;
  cursor: pointer;
}
.selectedDepositMethod {
  border: 1px solid #333333;
}
.depositMethodHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  user-select: none;
}
.depositMethodHeader img {
  -webkit-user-drag: none;
}
.depositMethodFooter {
  display: flex;
  color: #333333;
}
.depositMethodFooter p {
  font-size: 14px;
  font-weight: 600;
}
:deep(.flicking-camera) {
  gap: 20px;
}
:deep(.dp__input) {
  border-radius: 10px !important;
}
:deep(.dp__action_cancel:hover) {
  border: 1px solid #ffa2a2;
}
:deep(.dp__action_select) {
  background-color: #ff8989;
}
:deep(.dp__action_select:hover) {
  background-color: #ffa2a2;
}
:deep(.dp__menu) {
  border-radius: 10px;
}
.loader {
  width: 20px; /* Размер лоадера */
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.5);
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
.popUpNotifyBlock {
  background-color: white;
  border: 1px solid #e4e4e4;
  border-radius: 14px;
  position: absolute;
  top: 50%;
  padding: 18px;
  left: 50%;
  width: min(420px, calc(100vw - 32px));
  color: #2f2f2f;
  transform: translateY(-50%) translateX(-50%);
  z-index: 9999;
  box-shadow: 0 18px 44px rgba(0, 0, 0, 0.18);
}
.popUpNotify {
  position: relative;
}
.popUpNotifyContent {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.popUpNotifyContent .modalHeader {
  margin-bottom: 0 !important;
}
.popUpNotifyContent hr {
  border: 0 !important;
  border-top: 1px solid #e6e6e6 !important;
  margin: 0 !important;
}
.popUpHead {
  font-size: 30px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 10px;
}
.popUpHeadText {
  color: #2f2f2f;
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  margin: 0;
}
.popUpText {
  color: #333333;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.45;
  text-align: center;
  margin: 0;
}
.showPopUp {
  filter: blur(4px);
  pointer-events: none;
}
.writeUs {
  border-radius: 10px;
  background-color: #ff8989;
  border: 1px solid #ff8989;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 13px 22px;
  font-size: 16px;
  font-weight: 600;
  width: 100%;
  cursor: pointer;
  margin: 0;
  min-height: 48px;
}
.writeUs img {
  width: 18px;
  height: 18px;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.allNightButton {
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  border-radius: 10px;
  padding: 5px 15px 5px 15px;
  background-color: white;
  border: 1px solid #ff8989;
  transition: 0.3s ease;
  font-size: 14px;
}
.toggleAllNight {
  background-color: #ff8989;
  color: white;
  transition: 0.3s ease;
}
input,
textarea {
  outline: none;
  background-color: #ffffff;
  border-radius: 10px;
  border: 1px solid #d8dadc;
  padding: 15px;
  width: 100%;
  color: #333333;
}
@media (max-width: 968px) {
  .reservationBlock {
    width: 90vw;
    padding: 5%;
  }
  .commentInputArea textarea {
    height: 8vh;
  }
  .signSelector {
    width: 100%;
  }
  .myPlace,
  .modelPlace {
    flex-grow: 1;
  }
  .slider {
    width: 38vw;
  }
  .popUpNotifyBlock {
    padding: 16px;
    width: min(340px, calc(100vw - 40px));
  }
  .popUpText {
    font-size: 14px;
  }
  .writeUs {
    padding: 12px 18px;
  }
}
</style>
